import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Table } from 'antd';
import { Content, Loader, PageSectionHeader } from '@/components';
import { NAMESPACE } from '@/constants';
import { useRateCards } from './hooks/useRateCards';
import { EditableCell } from './components';
import { ActionBar, StyledContainer } from './RateCards.styles';

const renderTotalItemsCount = (total: number) => `Total ${total} items`;

const RateCards: FC = () => {
  const { t } = useTranslation(NAMESPACE.RATE_CARDS_PAGE);
  const {
    form,
    editingId,
    handleTableChange,
    handleCreateRateCard,
    rateCardList,
    isFetching,
    columns,
    limit,
    count,
    handleFormChange,
    handlePaginationChange,
    page,
    isLoading
  } = useRateCards();

  return (
    <>
      <PageSectionHeader>{t('rateCards')}</PageSectionHeader>
      <Content>
        <Form form={form} component={false} preserve onValuesChange={handleFormChange}>
          <StyledContainer>
            <ActionBar justify="end">
              <Button
                disabled={!!editingId || isFetching}
                onClick={handleCreateRateCard}
                size="large"
                type="primary"
              >
                {t('addRate')}
              </Button>
            </ActionBar>
            {isLoading ? (
              <Loader fullscreen={false} size="small" />
            ) : (
              <Table
                onChange={handleTableChange}
                columns={columns}
                scroll={{ y: 570, x: 2200 }}
                components={{
                  body: {
                    cell: EditableCell
                  }
                }}
                dataSource={rateCardList}
                loading={isFetching}
                rowClassName={({ isDraft }) => (isDraft ? 'draft' : '')}
                pagination={{
                  disabled: isFetching,
                  showQuickJumper: true,
                  totalBoundaryShowSizeChanger: 10,
                  showTotal: renderTotalItemsCount,
                  defaultPageSize: limit,
                  total: count,
                  onChange: handlePaginationChange,
                  current: page
                }}
              />
            )}
          </StyledContainer>
        </Form>
      </Content>
    </>
  );
};

export default RateCards;
